module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, $) {
'use strict';
	fox.registerWidget('FlashPlayer2', {
		configure: function (options) {
			this.callParent('configure', arguments);
			this.registerOptions('', {
				container: '#flash-player',
				renderPlayer: true,
				dontReloadPlayerOnChangeFormat: true,
				wmode: "opaque",
				standAloneMode: false,
				videoUrl: false,
				useOriginSize: false,
				useHash: false,
				playerConfig: {
					key: '#$0b7ed803a2f8f6a5142',
					showErrors: false,
					clip: {
						url: false,
						autoPlay: true,
						autoBuffering: true,
						provider: 'httpstreaming',
						scaling: 'fit'
					},
					plugins: {
						httpstreaming: {
							url: 'flowplayer.pseudostreaming-3.2.16.swf',
							queryString: encodeURIComponent('?position=${start}') // position param for prev. CDN
						},
						
						relateds: {
							isWaitForConfig: true // wait for config mode;
						},
						errorslogger: {
							serviceUrl: "http://overload.adultcentro.com/logerror.php",
							overloadMessageShowingMaxAttempts: 3,
							overloadSecondsAmount: 10,
						},
						controls: {
							"timeColor": "#414244",
							"durationColor": "#414244",
							"sliderColor": "#414244",
							"bufferColor": "#FFFFFF",
							"ratesConfig": {
								"backgroundColor": 15856113,
								"textColor": 4276804
							},
							"tooltips": {
								"buttons": true,
								"rates": ""
							},
							"autoHide": {
								"enabled": false
							}
						}
					}
				},
				'handleWom.runPlayer': {
					widget: '@this',
					event: '_changeFormat',
					callback: 'runPlayer'
				}
			});
		},

		init: function () {
			this.visual = !!this.getOption('template');
			this._videoFormat = null;
			this._bitrates = [];
			this._formatMap = {};
			this._contentId = null;

			window.addEventListener('orientationchange', fox.bind(function() {
				var htmlPlayer = $('#video_trailer')[0];

				if(!htmlPlayer || !htmlPlayer.videoWidth && !htmlPlayer.videoHeight) {
					return;
				}

				this.setPlayerSize(htmlPlayer.videoWidth, htmlPlayer.videoHeight, true);
			}, this), false);

			this.callParent('init', arguments);
		},

		

		preparePlayerConfig: function () {
			var clip;

			if (!fox.isEmpty(this.getFormatMap()) && this.getVideoFormat()) {
				clip = 'http://' + this.window.location.host + this.getFormatMap().view[this.getVideoFormat()].link;
			}
			else if (this.getOption('standAloneMode') && this.getOption('videoUrl')) {
				clip = this.getOption('videoUrl');
			}
            if(this.getOption('useHash')){
                if (clip.indexOf('publisher_auth=') === -1) {
                    clip = clip + (clip.indexOf('?') === -1 ? '?' : '%26') + 'publisher_auth=' + fox.getEnv('siteProps').publisher_auth;
                }
            }
            if(fox.getEnv('siteProps.settingId')){
				clip = clip + (clip.indexOf('?') === -1 ? '?' : '%26') + 'settingId=' + fox.getEnv('siteProps.settingId');
			}
			this.setOption('playerConfig', fox.mergeRecursive(this.getOption('playerConfig'), {
				clip: {
					url: clip,
					provider: 'httpstreaming',
					onStart: fox.bind(function () {
						this.window.streamTest = 1;
					}, this),
					onMetaData: fox.bind(this._setPlayerSize, this),
					onResized: fox.bind(this._setPlayerSize, this)
				},
				onError: fox.bind(function () {
					this.window.streamTest = 0;
				}, this),
				onStart: fox.bind(this.onStartPlayerHandler, this)

			}));

			this.setOption('playerConfig.plugins.controls.ratesConfig.values', this.getBitrates());

			if (fox.site.member) {
				this.setOption('playerConfig.plugins.controls', fox.mergeRecursive(this.getOption('playerConfig.plugins.controls'), {
					timelineThumbsSprite: this.getOption('disableTimeline') === true ? false : 'http://cdn-small.storage.adultcentro.com/' + this.getContentId() + '/thumb/timeline/sprite/w135i',
					timelineThumbBackgroundColor: this.getOption('playerConfig.plugins.controls.timelineThumbBackgroundColor') || '#F1F1F1',
					timelineThumbTextColor: this.getOption('playerConfig.plugins.controls.timelineThumbTextColor') || '#414244'
				}));
				if(!this.getOption('videoUrl') && this.getFormatMap().view[this.getVideoFormat()].preview === 1) {
					this.setOption('playerConfig.plugins.images.onFinish', {
						url: this.getOption('onFinishPlayerImage') || fox.getEnv('design.url') + '/images/customplayer.png',
						y: 'center',
						x: 'center',
						'goto': encodeURIComponent(this.getOption('onFinishPlayerUrl') || fox.getEnv('siteProps.ubs.joinUrl')),
						isProportionalScaling: true
					});
				}
			} else {

				if (!!fox.getEnv('siteProps.previewsDisabled') && fox.getEnv('siteProps.previewsDisabled') === 1) {
					this.setOption('stub', true);
					return;
				}

				this.setOption('playerConfig.plugins.images.onPause', {
						url: this.getOption('onPausePlayerImage'),
						y: 'center',
						x: 'center',
						'goto': encodeURIComponent(fox.getEnv('siteProps.ubs.joinUrl')) || '/join'
				});

				if (fox.getEnv('siteProps.perUserPreviewsCountLimit') && fox.getEnv('siteProps.perUserPreviewsCountLimit') !== 0) {
					this.setOption('playerConfig.plugins.controls.limit', {
						max: fox.getEnv('siteProps.perUserPreviewsCountLimit'),
						imageProperties: {
							url: encodeURIComponent(fox.getEnv('design.url')) + '/images/' + fox.getEnv('siteProps.currentOrientation') + '.jpg',
							'goto': encodeURIComponent(fox.getEnv('siteProps.ubs.joinUrl')),
							'window': '_parent',
							y: 'center',
							x: 'center'
						},
						labelProperties: {
							textColor: 0xffffff,
							text: ' free',
							x: 214,
							y: 26
						}
					});
				} else {
					this.setOption('playerConfig.plugins.images.onFinish', {
						url: this.getOption('onFinishPlayerImage') || this.getOption('onPausePlayerImage'),
						y: 'center',
						x: 'center',
						'goto': encodeURIComponent(fox.getEnv('siteProps.ubs.joinUrl')) || '/join'
					});
				}
			}

			return this;
		},

		setPlayerSize: function (wSize, hSize, hideToolbar) {
			var playerWidth;
			var playerHeight;

			var playerContainer = this.getPlayerContainer();
			
			playerWidth = playerContainer && playerContainer.clientWidth;
			
			if(playerWidth === 0) return;
			
			if (this.getOption('useOriginSize')) {
				playerHeight = hSize;
			} else {
				playerHeight = (playerWidth * hSize) / wSize;
			}

			playerHeight = hideToolbar ? playerHeight : (playerHeight += this.getOption('playerConfig.toolbarHeight') || 30);

			if (this.getOption('maxPlayerHeight') && this.getOption('maxPlayerHeight') < playerHeight) {
				playerHeight = 885;
			}

			$(this.getPlayerContainer()).height(playerHeight);
			
			return this;
		},

		_setPlayerSize: function (value) {
			var w, h;

			w = value.metaData.width;
			h = value.metaData.height;

			this.setAspectRatio(w, h);

			if (this.getOption('useOriginSize')) {
				w = $(this.getPlayerContainer()).width();
				h = this._calculateOriginHeight(w, value.metaData);
			}

			this.setPlayerSize(w, h, this.getOption('standAloneMode'));
		},

		_calculateOriginHeight: function (containerWidth, metaData) {
			var aspect = (metaData.width/metaData.height);

			return containerWidth/aspect;
		},

		getPlayerContainer: function() {
			if (this.visual) {
				this.playerContainer = this.rdom1(this.requireOption('renderTo'));
			} else {
				this.playerContainer = fox.dom.selectFirst(this.requireOption('container'));
			}

			if (!this.playerContainer) {
				return false;
			}

			if (!this.playerContainer.getAttribute('id')) {
				this.playerContainer.setAttribute('id', fox.uniqid('flashPlayer'));
			}

			return this.playerContainer;
		},

		embedPlayer: function() {
			if (!this.getPlayerContainer()) {
				return;
			}

			if (!!this.getOption('stub')) {
				$(this.options.container).html(fox.Zen(fox.getTemplate('playerStub')));
				return;
			}

			var version = window.swfobject.getFlashPlayerVersion(), hSize, wSize, videoFormat;

			if(this.getVideoFormat() && !fox.isEmpty(this.getFormatMap())){
				videoFormat = this.getFormatMap().view[this.getVideoFormat()].format;
			}

			if (videoFormat === 2) {
				hSize = 720;
				wSize = 1280;
			} else if (this.getOption('useContainerSizeOnInit') === true) {
				var c = this.getPlayerContainer();

				hSize = $(c).height();
				wSize = $(c).width();
			} else {
				hSize = 480;
				wSize = 640;
			}
			if (version.major > 0) {
				this.setPlayerSize(wSize, hSize, false);
				this.createFlashPlayer();
				return;
			}
			if ((navigator.userAgent.match(/iPhone/i)) || (navigator.userAgent.match(/iPod/i))) {
				this.createHtmlPlayer(hSize, true);
			} else {
				this.createHtmlPlayer(hSize);
			}
			
		},

		createFlashPlayer: function () {
			this.window.flowplayer(
				this.getOption('domNodeContainerLink') === true ? this.getPlayerContainer() : this.getPlayerContainer().getAttribute('id'),
				{
					src: fox._isNewFe ? require('../flash/flowplayer.commercial-3.2.16.swf') : (fox.getEnv('design.url') + "/flash/flowplayer.commercial-3.2.16.swf"),
					wmode: this.getOption('wmode')
				},
				this.getOption('playerConfig')
			);
		},

		createHtmlPlayer: function (hSize, ios) {
			var 
				container = $(this.getPlayerContainer()),
				player = $('#video_trailer', container),
				htmlPlayer = document.createElement('video'),
				source = document.createElement('source');

			htmlPlayer.id = 'video_trailer';
			htmlPlayer.style.width = htmlPlayer.style.height = '100%';
			htmlPlayer.poster = (this.getOption('playerConfig.plugins.images.onBegin.url')) ? decodeURIComponent(this.getOption('playerConfig.plugins.images.onBegin.url')) : 'http://cdn-small.nl.storage.adultcentro.com/' + this.getContentId() + '/thumb/primary/h'+ hSize +'i';
			htmlPlayer.controls = true;

			if (this.getOption('playerConfig.clip.autoPlay') === true) {
				htmlPlayer.autoplay = true;
			}

			source.type= 'video/mp4';
			source.src = decodeURIComponent(this.getOption('playerConfig.clip.url'));

			//console.log(source.src);
			
			fox.dom.on('loadedmetadata', htmlPlayer, fox.bind(function(){
				if (htmlPlayer.videoWidth && htmlPlayer.videoHeight) {
					this.setPlayerSize(htmlPlayer.videoWidth, htmlPlayer.videoHeight, true);
				}
			}, this));
			fox.dom.on('canplaythrough', htmlPlayer, fox.bind(function(){
				/* for iOS devices
				if video reaches buffer it's stops plaing
				try to fix this
				*/
				htmlPlayer.play();
			}, this));

			fox.dom.on('play', htmlPlayer, fox.bind(function(){
				this.dispatchEvent('player.play');
			}, this));
			fox.dom.on('pause', htmlPlayer, fox.bind(function(){
				this.dispatchEvent('player.pause');
			}, this));

			htmlPlayer.appendChild(source);

			if (ios === true) {
				var 
					imgWrapper = $('<div>').addClass('virt-player').css('zIndex', 1),
					image = $('<img>');

				if (imgWrapper.css('position') === 'static') {
					imgWrapper.css('position', 'relative');
				}

				container.html('');
				player = [];

				image.attr('src', htmlPlayer.poster).appendTo(imgWrapper.appendTo(container));

				if (this.getOption('standAloneMode')) {
					image.bind('error', fox.bind(function (e) {
						this.hookWrapper('bannerLoadError', {e: e});
					}, this));
				}

				$(htmlPlayer).css({
					opacity: 1,
					position: 'absolute',
					width: '100%',
					height: 'auto',
					left: 0,
					top: 0,
					zIndex: 3
				});

				container.css('position', 'relative');
			}

			if (player.length) {
				player.replaceWith(htmlPlayer);
				return;
			}

			container.append(htmlPlayer);
		}, 

		runPlayer: function() {
			if (this.getOption('renderPlayer')) {
				this.preparePlayerConfig();

				if (this.getOption('contentWidget')) {
					this.handleEvent(this.getOption('contentWidget'), 'addedToDom', fox.bind(this.embedPlayer, this));
				} else {
					setTimeout(fox.bind(this.embedPlayer, this), 100);
				}
			}
		},

		changeFormat: function(format) {
			this.setVideoFormat(format);
			this.buildBitrates().dispatchEvent('_changeFormat');
			return this;
		},

		buildBitrates: function() {
			var tempBitrates = [];
			fox.each(this.getFormatMap().view, function(val, name) {
				if (typeof(val.hd) !== 'undefined') {
					var template = {
						"value": val.height + "p.",
						"isHD": ((val.hd === 1) ? true : false),
						"onSelect": "changeFormat1",
						"onSelectArguments": name
					};

					if (this.getOption('dontReloadPlayerOnChangeFormat')) {
						template.onSelect = null;
						template.onSelectArguments = {
							clip: {
								url: decodeURIComponent('http://' + this.window.location.host + val.link),
								autoPlay: true,
								provider: 'httpstreaming',
								scale: 'orig'
							}
						};
					}

					if (name === this.getVideoFormat()) {
						template.isActive = true;
					}

					tempBitrates.push(template);
				}
			}, this);

			this.setBitrates(tempBitrates);
			return this;
		},

		onStartPlayerHandler: function (h) {
			switch (h.metaData.height) {
				case 1080:
					this.setVideoFormat('hd' + h.metaData.height);
				break;

				case 720:
					this.setVideoFormat('hd' + h.metaData.height);
				break;

				case 480:
					this.setVideoFormat('ipod');
				break;

				case 240: 
					this.setVideoFormat('ipod3g');
				break;
			}

			this.dispatchEvent('playerRunning', {
				format: this.getVideoFormat(),
				downloaded: !!this.getFormatMap().download
			});
		},

		bannerLoadError: function (ev) {},

		setVideoFormat: function(value) {
			this._videoInfo = value;
			return value;
		},

		getVideoFormat: function() {
			return this._videoInfo;
		},

		setFormatMap: function(value) {
			this._formatMap = value;
			return this;
		},

		getFormatMap: function() {
			return this._formatMap;
		},

		setBitrates: function(value) {
			this._bitrates = value;
		},

		getBitrates: function() {
			return this._bitrates;
		},

		setContentId: function(value) {
			this._contentId = value;
		},

		getContentId: function() {
			return this._contentId;
		},

		setAspectRatio: function (w, h) {
			this._aspectRatio = w/h;
		},

		getAspectRatio: function (w, h) {
			return this._aspectRatio;
		}

	}, 'Widget');
})(fox, fox.jQuery);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/publisher/widget/flashplayer2.js
// module id = 468
// module chunks = 4